import React from 'react';

import { Content } from './SimplePageContent.styles';
import { SimplePageContentProps } from './SimplePageContent.types';

export const SimplePageContent = ({ children }: SimplePageContentProps) => {
  return <Content variant="body1">{children}</Content>;
};
